import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { FormFieldErrorMessagesComponent } from '../form-field-error-messages/form-field-error-messages.component';

@Component({
  selector: 'app-form-input-control',
  standalone: true,
  imports: [CommonModule, FormFieldErrorMessagesComponent],
  templateUrl: './form-input-control.component.html',
  styleUrl: './form-input-control.component.scss',
})
export class FormInputControlComponent {
  @Input() formField: AbstractControl | null = null;
  @Input() labelName?: string;
  @Input() suffix?: string;

  isControlTouchedAndInvalid(control: AbstractControl | null) {
    return control?.invalid && control?.touched;
  }
}
